import { observeWindowSize } from 'bits/window'
import debounce from 'lodash.debounce'
import { Component, Vue } from 'vue-property-decorator'
import { Action } from 'vuex-class'

@Component
export default class extends Vue {
  private unobserveWindowSize
  @Action private resizeWindow

  private mounted(): void {
    this.unobserveWindowSize = observeWindowSize(debounce(this.resizeWindow, 250))
  }

  private beforeDestroy(): void {
    this.unobserveWindowSize && this.unobserveWindowSize()
  }
}
